// @flow
import { useRef, useEffect } from 'react';

// If section tag matches the URL hash, scroll to the ref element on page load.
const useScrollToId = (sectionTag: string, additionalOffset: number = 0, waitMs: number = 250) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current && window.location.hash === `#${sectionTag}`) {
      const scroll = () => {
        const { offsetTop } = ref.current;

        setTimeout(() => {
          window.scrollTo(0, offsetTop - additionalOffset);
        }, waitMs);
      };

      window.addEventListener('load', scroll, { once: true });

      return () => {
        window.removeEventListener('load', scroll);
      };
    }

    return () => {};
  }, [sectionTag, additionalOffset, waitMs]);

  return ref;
};

export default useScrollToId;
